<template>
  <v-card>
  <v-card-title class='subtitle-1 overline' >
    Invite an existing AppointmentGuru member
  </v-card-title>
  <v-card-text>
    <v-text-field persistent-hint
      v-model="email"
      label="Email or username"
      hint="The email or username that they use to log into AppointmentGuru" />
  </v-card-text>
  <v-card-actions >
    <v-spacer/>
    <v-btn @click="invite" >Invite</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  name: 'InviteMember'
}
</script>